module.exports = __webpack_public_path__ + "static/christyatstove-309f2033f9f3d6bcc52f1f3eccdacb67.jpg";